<template>
	<section class="section">
		<h1 class="title">{{ cat }}</h1>
		<RecipeList v-bind:recipes="recipes"></RecipeList>
	</section>
</template>

<script>
	import RecipeList from '@/components/RecipeList.vue'

	import {db} from '@/variables.js'

	export default {
		props: ['cat'],
		components: {
			RecipeList
		},
		data: function () {
			return {
				recipes: []
			}
		},
		created: function() {
			var vm = this
			db.query( 'recipes/by_category', {
				startkey: [vm.cat],
				endkey: [vm.cat, {}]
			}).then( function( res ) {
				console.log( res )
				vm.recipes = res.rows
			}).catch( function( err ) {
				throw err
			})
		}
	}
</script>
